module.exports = __webpack_public_path__ + "svg/flags/Saint Kitts and Nevis.svg";